import { managerFactory } from "@/factories/manager";
import { initializeCacheClient } from "@/manager/cache-client/initializeCacheClient";

export const cacheClientManager = managerFactory.create({
  initializer: initializeCacheClient,
});
